<template>
    <b-row>
        <b-col>
            <apply-voucher v-editable="blok"></apply-voucher>
        </b-col>
    </b-row>
</template>
<script>
import ApplyVoucher from "../../../components/cart/ApplyVoucher.vue";

export default {
    name: 'basket-voucher-code',
    props: {
        blok: Object
    },
    components: {
        ApplyVoucher,
    }    
}
</script>
